import React from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  increment,
  decrement,
  incrementAsync,
  decrementAsync,
} from "../../redux/allAction/counterActions";
const DemoReduxComponent = () => {
  const counter = useSelector((state) => state.counter);
  const meData = useSelector((state) => state.auth.meData);

  console.log(" i am getting me data from store----", meData);
  const dispatch = useDispatch();
  return (
    <div style={{ padding: "20px", fontFamily: "Arial" }}>
      {" "}
      <h2>Counter: {counter}</h2>{" "}
      <button onClick={() => dispatch(increment())}>Increment</button>{" "}
      <button
        onClick={() => dispatch(decrement())}
        style={{ marginLeft: "10px" }}
      >
        {" "}
        Decrement{" "}
      </button>{" "}
      <button
        onClick={() => dispatch(incrementAsync())}
        style={{ marginLeft: "10px" }}
      >
        Increment Async
      </button>
      <button
        onClick={() => dispatch(decrementAsync())}
        style={{ marginLeft: "10px" }}
      >
        Decrement Async
      </button>







      <hr style={{ margin: "20px 0" }} />
      <h3>Me Data:</h3>
      {meData ? <pre>{JSON.stringify(meData, null, 2)}</pre> : <p>No meData yet.</p>}
    </div>
  );
};
export default DemoReduxComponent;
